import { useNavigate } from "@tanstack/react-router";
import { TabBar } from "@/components/ui/tab-bar";
import { SpecializationsSection } from "@/components/admin/settings/SpecializationsSection";
import { AdminSettingsSectionShell } from "../AdminSettingsSectionShell";
import { defaultTabForSection, type AdminSettingsTab } from "../types";
import { EnrollmentQuestionnaireSection } from "./EnrollmentQuestionnaireSection";

const TABS: Array<{ value: AdminSettingsTab; label: string }> = [
  { value: "questionnaire", label: "Upitnik" },
  { value: "specializations", label: "Specijalizacije" },
];

export function TherapistOnboardingSection({ tab }: { tab?: AdminSettingsTab }) {
  const navigate = useNavigate({ from: "/dashboard/admin/settings" });
  const activeTab = tab ?? defaultTabForSection("therapist-onboarding") ?? "questionnaire";

  const setTab = (nextTab: string) =>
    navigate({
      search: { section: "therapist-onboarding", tab: nextTab as AdminSettingsTab },
    });

  return (
    <AdminSettingsSectionShell
      title="Onboarding terapeuta"
      description="Postavke koje oblikuju prijavni i početni terapeutski flow: upitnik i taksonomija specijalizacija."
      actions={
        <TabBar
          tabs={TABS}
          value={activeTab}
          onChange={setTab}
          ariaLabel="Onboarding terapeuta"
          mobileMode="scroll"
        />
      }
    >
      {activeTab === "specializations" ? (
        <SpecializationsSection />
      ) : (
        <EnrollmentQuestionnaireSection />
      )}
    </AdminSettingsSectionShell>
  );
}
